import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SocialProof } from './components/SocialProof';
import { EbookContent } from './components/EbookContent';
import { Benefits } from './components/Benefits';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-[#020611] flex justify-center font-sans selection:bg-primary/30 selection:text-primary" data-id="element-0">
      {/* Phone-shaped vertical container */}
      <div className="w-full max-w-[440px] bg-background text-foreground overflow-x-hidden shadow-[0_0_80px_-10px_rgba(212,168,87,0.15)] sm:my-6 sm:rounded-[2.5rem] sm:border sm:border-border/40 relative" data-id="element-1">
        <Hero data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <SocialProof data-id="element-4" />
        <EbookContent data-id="element-5" />
        <Benefits data-id="element-6" />
        <Bonuses data-id="element-7" />
        <Pricing data-id="element-8" />
        <Urgency data-id="element-9" />
        <Testimonials data-id="element-10" />
        <Guarantee data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
        <Footer data-id="element-14" />
      </div>
    </div>;
}